<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>打偷统计</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          />
          <el-table-column
            prop="count"
            label="转动次数"
            align="center"
          >
            <template scope="scope">
              {{ scientificFormat(scope.row.count) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="人均转动次数"
            align="center"
          >
            <template scope="scope">
              {{ scientificFormat(scope.row.count_avg) }}
            </template>
          </el-table-column>
          <el-table-column
            label="打统计"
            align="center"
          >
            <el-table-column
              prop="strike_count"
              label="打总数"
              align="center"
            />
            <el-table-column
              prop="strike_rate"
              label="打概率"
              align="center"
            >
              <template scope="scope">
                {{ scope.row.strike_rate }}%
              </template>
            </el-table-column>
            <el-table-column
              prop="strike_avg"
              label="人均被打"
              align="center"
            />
            <!--            <el-table-column-->
            <!--              prop="strike_base"-->
            <!--              label="打基础获得"-->
            <!--              align="center"-->
            <!--            >-->
            <!--              <template scope="scope">-->
            <!--                {{ scientificFormat(scope.row.strike_base) }}-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column
              prop="strike_bet_num"
              label="打获得"
              align="center"
            >
              <template scope="scope">
                {{ scientificFormat(scope.row.strike_bet_num) }}%
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="偷统计"
            align="center"
          >
            <el-table-column
              prop="steal_count"
              label="偷总数"
              align="center"
            />
            <el-table-column
              prop="steal_rate"
              label="偷概率"
              align="center"
            >
              <template scope="scope">
                {{ scope.row.steal_rate }}%
              </template>
            </el-table-column>
            <el-table-column
              prop="steal_avg"
              label="人均被偷"
              align="center"
            />
            <!--            <el-table-column-->
            <!--              prop="steal_base"-->
            <!--              label="偷基础"-->
            <!--              align="center"-->
            <!--            >-->
            <!--              <template scope="scope">-->
            <!--                {{ scientificFormat(scope.row.steal_base) }}-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column
              prop="steal_bet_num"
              label="偷获得"
              align="center"
            >
              <template scope="scope">
                {{ scientificFormat(scope.row.steal_bet_num) }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <stat ref="slot" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <rate ref="steal" :chart-title="'打偷总数'" :k-arr="steakCount" :color="steakCountColor" :k-title-arr="steakCountArr" />
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <rate ref="rate" :chart-title="'打偷概率1'" :k-arr="steakRate" :c="'%'" :color="steakRateColor" :k-title-arr="steakRateArr" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <rate ref="stealAvg" :chart-title="'人均被打偷'" :k-arr="steakAvgRate" :color="steakAvgRateColor" :k-title-arr="steakAvgRateArr" />
        </el-col>
      </el-row>

    </template>
  </BasicLayout>
</template>

<script>
import { getStealStrickStat } from '@/api/user/user_info'
import stat from '@/views/config/steal-strick-stat/components/stat.vue'
import rate from '@/views/config/steal-strick-stat/components/rate.vue'
import { getLastDates, scientificFormat } from '@/utils'
export default {
  name: 'StealStrickStat',
  components: {
    stat,
    rate
  },
  data() {
    return {
      total: 0,
      steakCount: ['strike_count', 'steal_count', 'attack_shield'],
      steakCountArr: ['打总数', '偷总数', '打盾次数'],
      steakCountColor: [0, 1, 2],
      steakRate: ['strike_rate', 'steal_rate', 'attack_shield_rate'],
      steakRateArr: ['打概率', '偷概率', '打盾概率'],
      steakRateColor: [2, 3, 4],
      steakAvgRate: ['strike_avg', 'steal_avg'],
      steakAvgRateArr: ['人均被打', '人均被偷'],
      steakAvgRateColor: [3, 4],
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }
    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }
    this.getTables()
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      getStealStrickStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data
          this.$refs.slot.refresh(this.tableData)
          this.$refs.steal.refresh(this.tableData)
          this.$refs.rate.refresh(this.tableData)
          this.$refs.stealAvg.refresh(this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
